import './Cube.css';

export default function Cube(params) {
  return (
    <div className="cube w-full h-full ">
      <div className="wrapper  h-full flex justify-center items-center">
        <div className="box w-32 h-32 relative  ">
          <div className="cart w-full h-full absolute text-center cart-front bg-secondary-200">
            JavaScripts
          </div>
          <div className="cart w-full h-full absolute text-center cart-back bg-secondary-300">
            React.js
          </div>
          <div className="cart w-full h-full absolute text-center cart-left bg-secondary-400">
            Django
          </div>
          <div className="cart w-full h-full absolute text-center cart-right bg-secondary-500">
            HTML
          </div>
          <div className="cart w-full h-full absolute text-center cart-top bg-secondary-600">
            CSS
          </div>
          <div className="cart w-full h-full absolute text-center cart-bottom bg-secondary-700 ">
            Next.js
          </div>
        </div>
      </div>
    </div>
  );
}
